import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-button-cancel',
  templateUrl: './st-button-cancel.component.html',
  styleUrls: ['./st-button-cancel.component.scss'],
  standalone: false
})
export class StButtonCancelComponent {

  @Input()
  idVal: string = 'buttonId';

  @Input()
  primary = false;

  @Input()
  label = 'Cancel';

  @Input()
  width?: string;

  @Input()
  backgroundColor: string = '#ffffff';

  @Input()
  fontColor: string = '#000000'

  @Output()
  onClick = new EventEmitter<Event>();
}
